<style scoped>
.tab {
  width: 100%;
  cursor: pointer;
  min-height: 48px;
  padding: 8px 16px 8px 16px;
}
.tab-active {
  border-top: 3px solid;
}
.tab:hover {
  background-color: rgb(0,0,0,0.1);
}
.mu-input {
  padding-bottom: 0px;
  margin-bottom: 0px;
  min-height: 0px;
  font-size: 12px;
  width: auto;
}
.focus-text {
  font-size: 24px;
}
.compare-message {
  padding-left: 16px;
}
</style>

<template>
  <mu-card v-loading="loading">
    <mu-row>
      <mu-col span="3">
        <div @click="tab = 'users'" class="tab" :class="tab === 'users' ? 'tab-active' : ''" :style="{ 'border-color': themePrimaryColor }">
          <div><small>{{$t('AnalyticsView.users')}}</small></div>
          <b class="focus-text">{{totalUsers}}</b>
          <div v-if="modelDays !== 0 && oldTotalUsers > 0" :style="stylePercentage(percentageTotalUsers)">
            <small><mu-icon :value="iconPercentage(percentageTotalUsers)" size="12"/>{{ Math.abs(percentageTotalUsers) }}%</small>
          </div>
        </div>
      </mu-col>
      <mu-col span="3">
        <div @click="tab = 'views'" class="tab" :class="tab === 'views' ? 'tab-active' : ''" :style="{ 'border-color': themePrimaryColor }">
          <div><small>{{$t('AnalyticsView.views')}}</small></div>
          <b class="focus-text">{{totalViews}}</b>
          <div v-if="modelDays !== 0 && oldTotalViews > 0" :style="stylePercentage(percentageTotalViews)">
            <small><mu-icon :value="iconPercentage(percentageTotalViews)" size="12"/>{{ Math.abs(percentageTotalViews) }}%</small>
          </div>
        </div>
      </mu-col>
    </mu-row>
    <small class="compare-message" v-if="modelDays !== 0 && (oldTotalUsers > 0 || oldTotalViews > 0)">{{$t('AnalyticsView.compare', { num: modelDays })}}</small>
    <chart :option="line" id="AnalyticsView" height="300px" />
    <mu-card-text>
      <mu-select v-model="modelDays">
        <mu-option v-for="(option, index) in optionsDays" :key="index" :label="option.text" :value="option.value"></mu-option>
      </mu-select>
    </mu-card-text>
  </mu-card>
</template>

<script>
import axios from "axios";

import theme from '@/mixins/theme.js'

import chart from '@/components/Charts/Charts.vue'
import echarts from 'echarts'

import langEn from './lang/en.json'
import langZh from './lang/zh.json'

export default {
  name: "AnalyticsView",
  props: ["channel"],
  mixins: [theme],
  components: {
  chart
  },
  data() {
    return {
      dates: [],
      oldDates: [],
      views: [],
      users: [],
      oldViews: [],
      oldUsers: [],
      totalViews: 0,
      totalUsers: 0,
      oldTotalViews: 0,
      oldTotalUsers: 0,
      modelDays: 7,
      
      tab: 'users',
      loading: false,
    };
  },
  watch: {
    channel(newValue) {
      this.getData(newValue._id);
    },
    modelDays() {
      this.getData(this.channel._id);
    }
  },
  computed: {
    days() {
      return [3, 7, 14, 28, 30, 60, 90, 180, 360];
    },
    optionsDays() {
      return this.days.map(d => {
        return { text: this.$t('AnalyticsView.days.display', { num: d}), value: d }
      }).concat({ text: this.$t('AnalyticsView.days.all'), value: 0 });
    },
    line() {
      return {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            animation: true
          },
        },
        grid: {
          left: '8%',
          right: '8%',
          top: '10%',
          bottom: '20%'
        },
        toolbox: {},
        dataZoom: [
          {
            show: true,
            realtime: true,
            dataBackground: {
              lineStyle: {
                color: this.themePrimaryColor
              },
              areaStyle: {
                color: this.themeSecondaryColor
              }
            },
            textStyle: {
              color: this.themeTextColor
            },
            fillerColor: 'rgba(0, 0, 0, 0.1)',
            handleStyle: {
              color: 'rgba(0, 0, 0, 0.2)'
            }
          },
        ],
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.dates,
            axisLine: {
              lineStyle: {
                color: this.themeTextColor
              }
            }
          },
          {
            type: "category",
            show: false,
            boundaryGap: false,
            data: this.oldDates,
            axisLine: {
              lineStyle: {
                color: this.themeTextColor
              }
            }
          },
        ],
        yAxis: {
          type: "value",
          boundaryGap: [0, "100%"],
          axisLine: {
            lineStyle: {
              color: this.themeTextColor
            }
          },
          minInterval: 1,
          max: 'dataMax'
        },
        series: [
          {
            name: this.tab === 'users' ? this.$t('AnalyticsView.users') : this.$t('AnalyticsView.views'),
            type: "line",
            smooth: true,
            symbol: "none",
            sampling: "average",
            itemStyle: {
              normal: {
              color: this.themePrimaryColor,
              }
            },
            areaStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                  offset: 0,
                  color: this.themePrimaryColor
                  },
                  {
                  offset: 1,
                  color: this.themeSecondaryColor
                  }
                ])
              }
            },
            data: this.tab === 'users' ? this.users : this.views
          },
        ]
      };
    },
    percentageTotalUsers() {
      if(this.modelDays > 0 && this.oldTotalUsers > 0) {
        return Math.round((this.totalUsers - this.oldTotalUsers)/ this.oldTotalUsers * 100 * 100) / 100
      } else {
        return 0;
      }
    },
    percentageTotalViews() {
      if(this.modelDays > 0 && this.oldTotalViews > 0) {
        return Math.round((this.totalViews - this.oldTotalViews)/ this.oldTotalViews * 100 * 100) / 100
      } else {
        return 0;
      }
    },
  },
  mounted() {
    this.getData(this.channel._id);
  },
  created() {
    this.$i18n.add('en', langEn); // Add English Translation
    this.$i18n.add('zh', langZh); // Add Traditional Chinese Translation
  },
  methods: {
    getData(channel_id) {
      this.loading = true;
      axios
      .get(this.$store.getters.urlApi + "analytics/views/channel/" + channel_id + '?days=' + this.modelDays, {
        headers: {
        token: this.$store.state.auth.token
        }
      })
      .then(response => {
        this.dates = response.data.data.dates;
        this.oldDates = response.data.data.oldDates;
        this.views = response.data.data.views;
        this.totalViews = response.data.data.totalViews;
        this.oldViews = response.data.data.oldViews;
        this.oldTotalViews = response.data.data.oldTotalViews;
        this.users = response.data.data.users;
        this.totalUsers = response.data.data.totalUsers;
        this.oldUsers = response.data.data.oldUsers;
        this.oldTotalUsers = response.data.data.oldTotalUsers;
        this.loading = false;
      });
    },
    iconPercentage(percent) {
      if(percent > 0) {
        return 'arrow_upward';
      } else if(percent < 0) {
        return 'arrow_downward';
      } else {
        return ''
      }
    },
    stylePercentage(percent) {
      if(percent > 0) {
        return { color: 'green' };
      } else if(percent < 0) {
        return { color: 'red' };
      } else {
        return ''
      }
    },
  },
};
</script>
